import { useAppSelector } from "../app/store";
import { TUserRoles } from "../types";

export default function useAuth(roles?: TUserRoles[]) {
  const { access_token, authInfo } = useAppSelector((state) => state.auth);
  const accessRole =
    authInfo?.role && roles?.length && roles?.includes(authInfo?.role);

  return access_token && (roles?.length ? accessRole : true);
}
